module.exports = __webpack_public_path__ + "img/awp.a4a325c7.png";